import { TNextCacheResetTimestampDB, TInitStoreLockedBy, TInitStore } from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum InitStoreActionTypes {
  AcquireLockAndThenUpdateNextCacheResetTimestampDB = 'AcquireLockAndThenUpdateNextCacheResetTimestampDB',
  UpdateNextCacheResetTimestampDBAndReleaseLock = 'UpdateNextCacheResetTimestampDBAndReleaseLock',
  UpdateInitStoreLockDetails = 'UpdateInitStoreLockDetails',
  InitStoreNoAction = 'InitStoreNoAction',
}

export class AcquireLockAndThenUpdateNextCacheResetTimestampDB implements Action {
  readonly type = InitStoreActionTypes.AcquireLockAndThenUpdateNextCacheResetTimestampDB;
  constructor(public lockFor: TInitStoreLockedBy) {}
}

export class UpdateNextCacheResetTimestampDBAndReleaseLock implements Action {
  readonly type = InitStoreActionTypes.UpdateNextCacheResetTimestampDBAndReleaseLock;
  constructor(public lockedBy: TInitStoreLockedBy, public nextCacheResetTimeStampDB: TNextCacheResetTimestampDB) {}
}

export class UpdateInitStoreLockDetails implements Action {
  readonly type = InitStoreActionTypes.UpdateInitStoreLockDetails;
  constructor(public lockDetails: TInitStore['lockDetails']) {}
}

export class InitStoreNoAction implements Action {
  readonly type = InitStoreActionTypes.InitStoreNoAction;
  constructor() {}
}

export type TInitStoreActions =
  | UpdateInitStoreLockDetails
  | AcquireLockAndThenUpdateNextCacheResetTimestampDB
  | UpdateNextCacheResetTimestampDBAndReleaseLock;
